import React from 'react';
import Header from '../components/Header';

const Download = () => {
  const handleDownload = () => {
    // Replace with your actual app's Play Store URL
    window.open('https://play.google.com/store/apps/details?id=com.example.app', '_blank');
  };

  return (
    <>
    <Header/>
    <div className="min-h-screen bg-gradient-to-br from-purple-400 via-pink-500 to-red-500 flex items-center justify-center px-4">
      <div className="max-w-4xl mx-auto text-center bg-white rounded-2xl shadow-2xl p-8 md:p-12">
        <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-4">
          Download Our App
        </h1>
        <p className="text-lg md:text-xl text-gray-600 mb-8">
          Experience the best in prenatal care, nutrition, and wellness right at your fingertips.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0 md:space-x-8 mb-8">
          <div className="flex-1">
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              onClick={handleDownload}
              className="cursor-pointer w-48 md:w-64 mx-auto transform hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="flex-1">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Why Download?</h2>
            <ul className="text-left text-gray-600 space-y-2">
              <li>✓ Personalized prenatal guidance</li>
              <li>✓ Nutrition tracking and tips</li>
              <li>✓ Wellness exercises and routines</li>
              <li>✓ Expert advice from professionals</li>
              <li>✓ Community support and forums</li>
            </ul>
          </div>
        </div>

        <div className="mt-8">
          <button
            onClick={() => window.open('https://wa.me/7972833428', '_blank')}
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-full text-lg transition-colors duration-300 shadow-lg flex items-center justify-center space-x-2"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
            </svg>
            <span>Contact on WhatsApp</span>
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default Download;